module.exports = __webpack_public_path__ + "img/management-active.ce067f76.svg";